import { TranslationRecord } from '../../../TranslationRecord';
import { plTranslations } from '../../../global-translations/pl';

export const plMessages: TranslationRecord = {
  ...plTranslations,
};
